var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('span',{staticClass:"name",style:(_vm.nameStyle)},[_vm._v(_vm._s(_vm.name))]),_c('span',{staticClass:"teacher",style:(_vm.teacherStyle)},[_vm._v(_vm._s(_vm.$t('teacherSchedule.honorificTitle')))])])}
var staticRenderFns = []

export { render, staticRenderFns }